import React from "react";
import { Button } from "@nextui-org/react";
import { FaDiscord } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";

function Footer() {
    return (
        <div className='footer1' id="contact" style={{ paddingTop: '200px', textAlign: 'center', background: '#8533ff', paddingBottom: '200px'}}>
            <h1 style={{ color: 'white', fontSize: '60px', fontWeight: 700 }}>join our community</h1>
            <br></br>
            <br></br>
            <div class=" sm:flex-col lg:flex-row justify-center" style={{ display: 'flex', }}>
                <div style={{margin:'20px'}} >
                    <Button background='white' style={{ color: "#8533ff", padding: '30px', fontSize: '20px', borderRadius: '40px' }} startContent={<FaDiscord style={{ fontSize: '30px' }} />}>
                        Join Discord
                    </Button>

                </div>
                <br></br>
                <br></br>
                <div style={{margin:'20px'}}>
                    <Button color="white" variant="bordered" style={{ color: "white", padding: '30px', fontSize: '20px', borderRadius: '40px' }} startContent={<FaTwitter />}>
                        Follow Twitter
                    </Button>
                    <br></br>

                </div>
                <br></br>
                <br></br>


            </div>
            <div style={{paddingTop:'85px'}}>
                    <a  href="/" style={{color:'white', fontSize:'20px'}}>Read our whitepaper</a>
                </div>
        </div>
    )
}

export default Footer;
